export const calculatorDataSelector = (state) =>
  state.calculator.calculatorData;
export const editCalculatorSelector = (state) =>
  state.calculator.editCalculator;
export const calculatorPlatformsSelector = (state) =>
  state.calculator.platforms;

export const showMobileModalSelector = (state) =>
  state.calculator.showMobileModal;
